// Fix for React DevTools "history is not defined" error - must be imported first
import './devtools-fix';

import React, { useEffect } from 'react';
import { render } from 'react-dom';
import { BrowserRouter, withRouter } from 'react-router-dom';
import AppRoutes from './pages/routes/AppRoutes';
import '../../css/index.scss';
import '../../../public/style.css';
import { AriaLiveContextProvider, MessagePopupCore } from '@utahdts/dts-react-common';
import { FirebaseAppProvider } from './auth/FirebaseAppProvider';
import { FirebaseAnalyticsProvider } from './auth/FirebaseAnalyticsProvider';
import { FirebaseAuthProvider } from './auth/FirebaseAuthProvider';
import firebaseConfig from './firebaseConfig';
import historyStore from './mobx/historyStore';
import UtahHeader from './UtahHeader/UtahHeader';
import HeadTags from './HeadTags';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import ReduxToMobXShim from './redux/ReduxToMobXShim';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { createDragDropManager } from 'dnd-core';
import reduxStore from './redux/ReduxStore';
import CompanyPopup from '../misc/CompanyPopup';
import Analytics from './analytics/Analytics';
import ErrorBoundary from '../misc/ErrorBoundary';
import RateLimitBanner from '../misc/RateLimitBanner';
import Footer from '../misc/Footer';
import loadDebugFlag from './debug/loadDebugFlag';

const propTypes = {
  history: PropTypes.object.isRequired,
};

const AppFunc = ({ history }) => {

  useEffect(() => {
    if (!history) {
      console.error('history does not exist for app');
    }
    historyStore.history = history;

    // Load the server DEBUG flag and enable/disable the in-browser devLogger.
    loadDebugFlag();

    // Initialize Google Analytics
    Analytics.initialize('G-FL8RC84FLW');

    // Track page views
    history.listen(() => {
      Analytics.onPageChange();
    });
  }, [history]);

  return (
    <FirebaseAppProvider config={firebaseConfig}>
      <FirebaseAnalyticsProvider>
        <FirebaseAuthProvider>
          <AriaLiveContextProvider>
            <ReduxToMobXShim>
              <HeadTags />
              <UtahHeader />
              <main className="main-content-wrapper">
                <section className="section-content">
                  <ErrorBoundary>
                    <RateLimitBanner />
                    <AppRoutes />
                  </ErrorBoundary>
                </section>
              </main>
              <Footer />
              <MessagePopupCore />
              <CompanyPopup />
            </ReduxToMobXShim>
          </AriaLiveContextProvider>
        </FirebaseAuthProvider>
      </FirebaseAnalyticsProvider>
    </FirebaseAppProvider>
  );
};

AppFunc.propTypes = propTypes;

const App = withRouter(AppFunc);

// Authentication is handled by Firebase Authentication (id.utah.gov custom OIDC
// provider) via <FirebaseAuthProvider>; the legacy dts-react-common OIDCOptions
// redirect config has been removed.

// Provide a drag/drop manager explicitly to satisfy lint/static analysis requiring manager prop
const dndManager = createDragDropManager(HTML5Backend);

const div = document.createElement('div');
document.body.appendChild(div);

render(
  <BrowserRouter basename={'/'}>
    <DndProvider backend={HTML5Backend} manager={dndManager}>
      <Provider store={reduxStore}>
        <App />
      </Provider>
    </DndProvider>
  </BrowserRouter>,
  div,
);
